import React from 'react';
import {
  Box,
  Grid,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { FormLabel } from 'react-bootstrap';

function showTableData({
  ticket,
  ticketBackgroundStyle = { backgroundColor: '#f5f5f5' },
  firstValueLabel,
  value,
  secondValueLabel,
  secondValue,
  isRequired,
  extraText,
}: {
  ticket: string | React.ReactNode,
  ticketBackgroundStyle?: string | any,
  firstValueLabel?: string,
  value: string | React.ReactNode,
  secondValueLabel?: string,
  secondValue?: string | React.ReactNode,
  isRequired?: boolean,
  extraText?: string,

}) {
  return (
    <TableRow>
      <th style={ticketBackgroundStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>
            {ticket}
          </span>
          {isRequired ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '0 6px',
                backgroundColor: '#dc3545',
                color: 'white',
                borderRadius: '5px',
                fontSize: '10px',
              }}
            >
              必須
            </Box>
          ) : ('')}
        </Box>
      </th>
      <TableCell
        sx={{
          flexDirection: 'row',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        >
          {firstValueLabel && (
            <Grid
              item
              xs={12}
              sm={0.7}
            >
              <FormLabel>
                {firstValueLabel}
              </FormLabel>
            </Grid>
          )}
          <Grid
            item
            xs={11.3}
            sm={secondValue ? 5.3 : 12}
          >
            <span className="w-100">
              {value}
            </span>
          </Grid>

          {secondValueLabel && (
            <Grid
              item
              xs={12}
              sm={0.7}
            >
              <FormLabel>
                {secondValueLabel}
              </FormLabel>
            </Grid>
          )}
          {secondValue && (
            <Grid
              item
              xs={11.3}
              sm={5.3}
            >
              <span>
                {secondValue}
              </span>
            </Grid>
          )}
        </Grid>

        <Typography
          fontSize={12}
          color="gray"
        >
          {extraText ?? ''}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default showTableData;
